import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBriefcase(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.5 6.5h-2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-2m-9 0v-1a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1m-9 0h9"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBriefcase);
export default ForwardRef;
